export default () => ({
  statuses:null,
  formTypeStatuses:null,
});
